const watchLaterConstant = {
    ADD_TO_WATCHLATER: "ADD_TO_WATCHLATER",
    REMOVE_FROM_WATCHLATER: "REMOVE_FROM_WATCHLATER",
    SET_WATCHLATER: "SET_WATCHLATER",
    RESET_WATCHLATER: "RESET_WATCHLATER",
};

const likesConstant = {
    SET_LIKEDVIDEOS: "SET_LIKEDVIDEOS",
    ADD_TO_LIKEDVIDEOS: "ADD_TO_LIKEDVIDEOS",
    REMOVE_FROM_LIKEDVIDEOS: "REMOVE_FROM_LIKEDVIDEOS",
    RESET_LIKEDVIDEOS: "RESET_LIKEDVIDEOS",
};

const historyConstant = {
    SET_HISTORY: "SET_HISTORY",
    ADD_TO_HISTORY: "ADD_TO_HISTORY",
    REMOVE_FROM_HISTORY: "REMOVE_FROM_HISTORY",
    RESET_HISTORY: "RESET_HISTORY",
};

const playlistConstant = {
    SET_PLAYLIST: "SET_PLAYLIST",
    RESET_PLAYLIST: "RESET_PLAYLIST",
    ADD_PLAYLIST: "ADD_PLAYLIST",
    REMOVE_PLAYLIST: "REMOVE_PLAYLIST",
    GET_PLAYLIST_VIDEOS: "GET_PLAYLIST_VIDEOS",
    ADD_VIDEO_TO_PLAYLIST: "ADD_VIDEO_TO_PLAYLIST",
    REMOVE_VIDEO_FROM_PLAYLIST: "REMOVE_VIDEO_FROM_PLAYLIST",
};

export { watchLaterConstant, likesConstant, historyConstant, playlistConstant };
